import { createFileRoute } from "@tanstack/react-router";
import ProductHubList from "@/pages/ProductHubList";

export const Route = createFileRoute("/pressure-washers/reviews")({
  component: () => <ProductHubList hubSlug="pressure-washers" variant="reviews" />,
});
